import { Key } from "react";
import { MDSToggleButtonGroupItem, MDSToggleButtonGroup } from "@/mds";
import styled from "@emotion/styled";

interface CollectionsFacetFilterToggleButtonProps {
  onSelectMode: (keys: Set<Key>) => void;
  selectedModeKey: string;
}

export const CollectionsFacetFilterToggleButton = ({
  onSelectMode,
  selectedModeKey,
}: CollectionsFacetFilterToggleButtonProps) => {
  return (
    <ToggleGroupWrapper>
      <MDSToggleButtonGroup
        selectionMode="single"
        onSelectionChange={onSelectMode}
        selectedKeys={[selectedModeKey]}
      >
        <MDSToggleButtonGroupItem ariaLabel="In any of" id="in-any-of">
          In any of
        </MDSToggleButtonGroupItem>
        <MDSToggleButtonGroupItem ariaLabel="In all of" id="in-all-of">
          In all of
        </MDSToggleButtonGroupItem>
      </MDSToggleButtonGroup>
    </ToggleGroupWrapper>
  );
};

const ToggleGroupWrapper = styled.div`
  padding-block: ${({ theme }) => theme.spacing["2"]};
  padding-inline: ${({ theme }) => theme.spacing["5"]};
`;
